import { useGetConfig } from "@onefront/forrestjs-react-root";
import { useServiceLogin } from "./use-service-login";
import { useQueryString } from "../../utils/use-query-string";

export const useDelegatedToken = () => {
  const { getItem, removeItem } = useQueryString();
  const serviceLogin = useServiceLogin();
  const tokenParam = useGetConfig("one.auth.token.param", "token");

  const tokenValue = getItem(tokenParam);

  return {
    token: tokenValue,
    clear: () => removeItem(tokenParam),
    validate: () => serviceLogin.validate(tokenValue)
  };
};
